// eslint-disable-next-line
export default {
    // Auth
    "auth.login": "Вхід",
    "auth.email": "Email",
    "auth.password": "Пароль",
    "auth.enterEmail": "Введіть ваш email",
    "auth.enterPassword": "Введіть пароль",
    "auth.loginButton": "Увійти",
    "auth.loggingIn": "Вхід...",
    "auth.loginTitle": "Вхід до системи",
    "auth.loginDescription": "Введіть ваш email та пароль для входу",
    "auth.logout": "Вийти",
    "auth.authError": "Помилка авторизації",

    // Common
    "common.loading": "Завантаження...",
    "common.save": "Зберегти",
    "common.cancel": "Скасувати",
    "common.delete": "Видалити",
    "common.edit": "Редагувати",
    "common.create": "Створити",
    "common.close": "Закрити",
    "common.confirm": "Підтвердити",
    "common.yes": "Так",
    "common.no": "Ні",
    "common.search": "Пошук",
    "common.filter": "Фільтр",
    "common.settings": "Налаштування",
    "common.active": "Активний",
    "common.inactive": "Неактивний",
    "common.blocked": "Заблокований",
    "common.total": "Всього",
    "common.deleteUser": "Видалити користувача",
    "common.resetPassword": "Скинути пароль",
    "common.confirmDelete": "Підтвердити видалення",
    "common.deleteConfirmText": "Ви впевнені, що хочете видалити цього користувача? Цю дію неможливо скасувати.",

    // Roles
    "role.admin": "Адміністратор",
    "role.teacher": "Вчитель",
    "role.student": "Учень",

    // Navigation
    "nav.dashboard": "Панель керування",
    "nav.users": "Користувачі",
    "nav.students": "Учні",
    "nav.teachers": "Вчителі",
    "nav.courses": "Курси",
    "nav.schedule": "Розклад",
    "nav.grades": "Оцінки",
    "nav.last_entry": "Останній вхід",
    "nav.visits": "Відвідини",
    "nav.never": "Ніколи",

    // Admin Dashboard
    "admin.title": "Панель адміністратора",
    "admin.createTeacher": "Створити вчителя",
    "admin.systemUsers": "Користувачі системи",
    "admin.userManagement": "Керування всіма користувачами системи",
    "admin.stats.admins": "Адміни",
    "admin.stats.teachers": "Вчителі",
    "admin.stats.students": "Учні",
    "admin.block": "Заблокувати",
    "admin.unblock": "Розблокувати",

    // Teacher Dashboard
    "teacher.title": "Панель вчителя",
    "teacher.inviteStudent": "Запросити учня",
    "teacher.myStudents": "Мої учні",
    "teacher.studentManagement": "Керування учнями у ваших групах",
    "teacher.noStudents": "У вас ще немає учнів",
    "teacher.inviteFirst": "Запросіть першого учня, натиснувши кнопку вище",
    "teacher.addedOn": "Додано:",

    // Student Dashboard
    "student.title": "Особистий кабінет учня",
    "student.personalInfo": "Особиста інформація",
    "student.yourData": "Ваші дані в системі",
    "student.fullName": "Повне ім'я",
    "student.role": "Роль",
    "student.status": "Статус",
    "student.courses": "Курси",
    "student.coursesDesc": "Мої курси та матеріали",
    "student.schedule": "Розклад",
    "student.scheduleDesc": "Розклад занять",
    "student.grades": "Оцінки",
    "student.gradesDesc": "Мої оцінки та досягнення",
    "student.notifications": "Сповіщення",
    "student.updates": "Останні оновлення та оголошення",
    "student.welcome": "Ласкаво просимо до системи!",
    "student.welcomeDesc":
        "Ви успішно зареєстровані в системі керування школою. Тут ви зможете переглядати свої курси, розклад та оцінки.",
    "student.today": "Сьогодні",
    "student.featuresInDev": "Функції в розробці",
    "student.featuresDesc":
        "Додаткові функції для студентів (курси, завдання, оцінки) будуть додані в наступних версіях системи.",
    "student.info": "Інформація",

    // Password Change
    "password.change": "Зміна пароля",
    "password.new": "Новий пароль",
    "password.confirm": "Підтвердіть пароль",
    "password.required": "Необхідно змінити тимчасовий пароль для продовження роботи",
    "password.enter": "Введіть новий пароль для вашого облікового запису",
    "password.minLength": "Мінімум 6 символів",
    "password.repeat": "Повторіть новий пароль",
    "password.saving": "Збереження...",
    "password.success": "Пароль успішно змінено",
    "password.error": "Помилка під час зміни пароля",
    "password.minError": "Пароль повинен містити щонайменше 6 символів",
    "password.mismatch": "Паролі не збігаються",

    // Create Teacher Modal
    "createTeacher.title": "Створити вчителя",
    "createTeacher.description":
        "Введіть дані нового вчителя. На вказаний email буде надіслано запрошення.",
    "createTeacher.fullName": "Повне ім'я",
    "createTeacher.fullNamePlaceholder": "Іванов Іван Іванович",
    "createTeacher.emailPlaceholder": "teacher@school.ua",
    "createTeacher.creating": "Створення...",
    "createTeacher.success": "Вчителя успішно створено",
    "createTeacher.error": "Помилка створення вчителя",
    "createTeacher.exists": "Користувач з таким email вже існує",

    // Invite Student Modal
    "inviteStudent.title": "Запросити учня",
    "inviteStudent.description": "Введіть дані нового учня. На вказаний email буде надіслано запрошення.",
    "inviteStudent.fullName": "Повне ім'я",
    "inviteStudent.fullNamePlaceholder": "Петров Петро Петрович",
    "inviteStudent.emailPlaceholder": "student@school.ua",
    "inviteStudent.sending": "Надсилання запрошення...",
    "inviteStudent.success": "Учня успішно запрошено",
    "inviteStudent.error": "Помилка запрошення учня",

    // System
    "system.title": "Система дистанційної освіти",
    "system.error": "Системна помилка",
    "system.networkError": "Помилка мережі",
    "system.unauthorized": "Неавторизований доступ",
    "system.forbidden": "Доступ заборонено",
    "system.notFound": "Не знайдено",
    // Trainers
    "messages.userDeleted": "Користувача успішно видалено",
    "messages.passwordReset": "Пароль скинуто та надіслано на email",
    "messages.deleteError": "Помилка під час видалення користувача",
    "messages.resetError": "Помилка під час скидання пароля",

    "training.start": "Почати тренування",
    "trainings.title": "Модулі тренувань",
    "trainings.memory": "Тренування пам'яті",
    "trainings.memory.description": "Вправи для тренування пам'яті учнів",
    "trainings.logic": "Логічні задачі",
    "trainings.logic.description": "Логічні задачі та головоломки для учнів",
    "trainings.back": "Назад",
    "trainig.notImplemented": "Цей модуль тренування ще не реалізовано",
    // Mental arithmetics
    "trainings.mental": "Ментальна арифметика",
    "trainings.mental.description": "Тренування ментальної арифметики для учнів",
    "mentalArithmetic": "Ментальна арифметика",
    "trainer": "Тренажер",
    "flashCards": "Флеш-картки",
    "additionSubtraction": "Додавання / віднімання",
    "multiplicationDivision": "Множення / ділення",
    "selectTrainerSettings": "Виберіть налаштування тренажера",
    "selectCardsSettings": "Виберіть налаштування флеш-карток",
    "selectMultiSettings": "Виберіть налаштування тренажера",
    "go": "Старт",
    "theme": "Тема",
    "difficulty": "Складність",
    "digits": "Розрядність",
    "actionsCount": "Кількість дій",
    "inputTime": "Час на введення відповіді",
    "speed": "Швидкість",
    "start": "Старт",
    "stop": "Стоп",
    "settings": "Налаштування",
    "continue": "Продовжити",
    "simple": "Просто",
    "brother": "Брат",
    "friend": "Друг",
    "friendBrother": "Друг + Брат",
    "transitions": "Переходи",
    "allThemes": "Всі теми",
    "multiplication": "Множення",
    "division": "Ділення",
    "squaring": "Піднесення до квадрату",
    "performExercise": "Виконуйте вправу",
    "yourAnswer": "Ваша відповідь:",
    "correct": "Правильно",
    "incorrect": "Неправильно",
    "answer": "Відповідь",
    "sec": "сек",
    "multiplier": "Множник",
    "divisor": "Дільник",
    "any": "Будь-який",
    "multiplicationTable": "Таблиця множення",
    "byMultiplicationTable": "За таблицею множення",
    "resetAllSettings": "Скинути всі налаштування та перезавантажити сторінку?",
    "difficulties": {
        "0-4": "0-4",
        "0-5": "0-5",
        "0-6": "0-6",
        "0-7": "0-7",
        "0-8": "0-8",
        "0-9": "0-9",
        "4": "4",
        "3": "3",
        "2": "2",
        "1": "1",
        "9": "9",
        "8": "8",
        "7": "7",
        "6": "6",
        "5": "5",
        "50Plus": "50 +",
        "50Minus": "50 -",
        "100Plus": "100 +",
        "100Minus": "100 -"
    },
    "multiDifficulties": {
        "multiplicationTable": "Таблиця множення",
        "2x1": "II x I",
        "3x1": "III x I",
        "2x2": "II x II",
        "4x1": "IIII x I",
        "3x2": "III x II",
        "base50": "База 50",
        "base100": "База 100",
        "base200": "База 200",
        "byMultiplicationTable": "За таблицею множення",
        "2div1": "II / I",
        "3div1": "III / I",
        "4div1": "IIII / I",
        "2div2": "II / II",
        "3div2": "III / II",
        "4div2": "IIII / II",
        "4div3": "IIII / III",
        "2-10": "2-10",
        "on5": "на 5",
        "11-19": "11-19",
        "20-30": "20-30",
        "30-70": "30-70",
        "80-120": "80-120"
    },
    "multiThemes": {
        "multiplication": "Множення",
        "division": "Ділення",
        "squaring": "Піднесення до квадрату"
    },
    "cardsDifficulties": {
        "0-4": "0-4",
        "0-9": "0-9"
    }
}